/* tslint:disable:import-spacing no-trailing-whitespace no-inferrable-types */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy
}               from '@angular/core';

import {Logger} from "@/util/logger";

@Component({
  selector: 'admin-toolbar',
  template: `
    <mat-toolbar color="primary" class="admin-toolbar">

      <button mat-icon-button (click)="toggle()" style="background: transparent; border: 0; color: white; outline: none;">
        <mat-icon style="margin-top: 8px;">menu</mat-icon>
      </button>

      <img src="assets/images/line-sim-icon-512.png" width="36" style="margin-right: 12px;">

      <h1 class="admin-section-name">Administration - {{title}}</h1>
    </mat-toolbar>
  `
})
export class AdminToolbar  implements OnInit, OnDestroy {

  /** how the template tells us which section of admin area we are in */
  @Input() section: string;

  /** helper to bubble up a request to toggle the side bar */
  @Output() toggleSidebar  = new EventEmitter<any>();

  /** the sub-title for the header */
  public title: string;

  /** initialize component */
  ngOnInit(): void {

    this.title = this.section;

    Logger.debug(`[AdminToolbar] setting up (${this.title})...`);

  }

  /** open or close the side nav */
  toggle() {

    this.toggleSidebar.emit(null);
  }

  /** tear down component */
  ngOnDestroy(): void {

    Logger.debug(`[AdminToolbar] destroying (${this.title}).`);

  }

}
